var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H175L200 25V200H0V0Z",
    fill: "#6666FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 75H15V15H105V75ZM22.5 67.5H97.5V22.5H22.5V67.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60C57.0333 60 54.1332 59.1203 51.6665 57.472C49.1997 55.8238 47.2771 53.4812 46.1418 50.7403C45.0065 47.9994 44.7094 44.9834 45.2882 42.0737C45.867 39.1639 47.2956 36.4912 49.3934 34.3934C51.4912 32.2956 54.1639 30.867 57.0737 30.2882C59.9834 29.7094 62.9994 30.0065 65.7403 31.1418C68.4812 32.2771 70.8238 34.1997 72.4721 36.6665C74.1203 39.1332 75 42.0333 75 45C75 48.9783 73.4197 52.7936 70.6066 55.6066C67.7936 58.4197 63.9783 60 60 60ZM60 37.5C58.5166 37.5 57.0666 37.9399 55.8332 38.764C54.5999 39.5881 53.6386 40.7594 53.0709 42.1299C52.5033 43.5003 52.3547 45.0083 52.6441 46.4632C52.9335 47.918 53.6478 49.2544 54.6967 50.3033C55.7456 51.3522 57.082 52.0665 58.5368 52.3559C59.9917 52.6453 61.4997 52.4968 62.8701 51.9291C64.2406 51.3614 65.4119 50.4002 66.236 49.1668C67.0601 47.9334 67.5 46.4834 67.5 45C67.5 43.0109 66.7098 41.1032 65.3033 39.6967C63.8968 38.2902 61.9891 37.5 60 37.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 41.25H82.5V48.75H90V41.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 41.25H30V48.75H37.5V41.25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105 82.5H15V90H105V82.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105 97.5H15V105H105V97.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.1086552156fa92f071f47d2a23180e0d.svg";
export { ForwardRef as ReactComponent };